


import { FeiraProvider } from "../Contexts/FeiraContext";
import { useParams } from "react-router-dom";
import MapaLoader from "../pages/Mapa/MapaLoader";

const PaginaMapaIndependente = () => {
  const { idFeira } = useParams();

  return (
    <FeiraProvider idFeira={idFeira}>
      <MapaLoader />
    </FeiraProvider>
  );
};

export default PaginaMapaIndependente;